import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/upload.svg'
import _imports_1 from '@/assets/images/download.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-8d8a30cc")

_pushScopeId("data-v-8d8a30cc")
const _hoisted_1 = { class: "person-select-dialog-content" }
const _hoisted_2 = { class: "batch-ticket-title" }
const _hoisted_3 = { id: "batch-ticket-form" }
const _hoisted_4 = { class: "batch-dialog-text" }
const _hoisted_5 = { style: {"display":"flex","height":"100%"} }
const _hoisted_6 = { class: "content-left" }
const _hoisted_7 = {
  key: 0,
  class: "before-template"
}
const _hoisted_8 = { style: {"display":"inline-block"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { style: {"float":"right","display":"inline-block"} }, "已变更", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "empty-tip1" }, [
  /*#__PURE__*/_createVNode("span", null, "所选工单模版以下字段全部为空或所选值相同，可批量进行选择")
], -1)
const _hoisted_11 = {
  key: 2,
  class: "empty-tip"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "el-icon-warning" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "所选工单模版字段都不为空，无法进行批量选择", -1)
const _hoisted_14 = { class: "change-btn" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-sort",
  style: {"transform":"rotate(90deg)"}
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 变更工单模版")
const _hoisted_17 = { class: "batch-ticket-top" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "上传附件", -1)
const _hoisted_20 = {
  key: 0,
  class: "file-list-box"
}
const _hoisted_21 = { class: "file-name" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_24 = { class: "batch-ticket-bottom" }
const _hoisted_25 = { class: "attach-img-box" }
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("挂起")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("继 续")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("已解决")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TemplateGenerator = _resolveComponent("TemplateGenerator")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_TinymceEditor = _resolveComponent("TinymceEditor")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_form = _resolveComponent("el-form")
  const _component_ticket_template_change_multi = _resolveComponent("ticket-template-change-multi")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, "批量处理 " + _toDisplayString(_ctx.ticketsId.length) + " 条工单，属于" + _toDisplayString(_ctx.templateName), 1),
        _createVNode(_component_el_form, {
          model: _ctx.ruleForm,
          ref: "ruleFormRef",
          "label-position": "left",
          style: {"height":"calc(100% - 37px)"}
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (_ctx.beforeTemplateName)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.beforeTemplateName), 1),
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true),
                (Object.keys(_ctx.templateValue).length > 0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_10,
                      (Object.keys(_ctx.template).length > 0)
                        ? (_openBlock(), _createBlock(_component_TemplateGenerator, {
                            key: 0,
                            ref: "templateGenerator",
                            "template-data": _ctx.template,
                            value: _ctx.templateValue,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateValue = $event))
                          }, null, 8, ["template-data", "value"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _hoisted_13
                    ])),
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showChangeTemplate = true)),
                    type: "primary",
                    plain: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_15,
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_el_form_item, {
                    label: "下一阶段：",
                    prop: "nextProcess"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleForm.nextProcess,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ruleForm.nextProcess = $event)),
                        onChange: _ctx.changeNextProcess,
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processLabels, (l) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: l.id,
                              value: l.id,
                              label: l.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "处理人：",
                    prop: "nextHandler"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        clearable: "",
                        modelValue: _ctx.ruleForm.nextHandler,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ruleForm.nextHandler = $event)),
                        placeholder: "请选择",
                        filterable: ""
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.handlers, (p) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: p.id,
                              value: p.ldap,
                              label: p.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_upload, {
                    multiple: "",
                    "show-file-list": false,
                    ref: "fileUploader",
                    class: "upload-file",
                    "http-request": _ctx.uploadFile,
                    "on-preview": _ctx.handlePreview,
                    "on-remove": _ctx.handleRemove,
                    action: "javascript:void(0)"
                  }, {
                    default: _withId(() => [
                      _withDirectives(_createVNode(_component_el_button, {
                        class: "upload-btn",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_18,
                          _hoisted_19,
                          (_ctx.fileList.length > 0)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.showUploadFileList)
                                  ? (_openBlock(), _createBlock("i", {
                                      key: 0,
                                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showUploadFileList = false), ["stop"])),
                                      class: "icon-arrow el-icon-arrow-up"
                                    }))
                                  : (_openBlock(), _createBlock("i", {
                                      key: 1,
                                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showUploadFileList = true), ["stop"])),
                                      class: "icon-arrow el-icon-arrow-down"
                                    }))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 512), [
                        [
                          _directive_loading,
                          _ctx.uploading,
                          void 0,
                          {
                            fullscreen: true,
                            lock: true
                          }
                        ]
                      ]),
                      (_ctx.showUploadFileList && _ctx.notImageList(_ctx.fileList).length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (f, i) => {
                                return (_openBlock(), _createBlock(_Fragment, null, [
                                  (!_ctx.checkImage(f.name))
                                    ? (_openBlock(), _createBlock("li", {
                                        key: f.name
                                      }, [
                                        _createVNode("span", null, [
                                          _createVNode("span", _hoisted_21, _toDisplayString(f.name), 1),
                                          _createVNode(_component_el_link, {
                                            class: "file-download",
                                            href: f.url,
                                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                                            target: "_blank"
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_22
                                            ]),
                                            _: 2
                                          }, 1032, ["href"])
                                        ]),
                                        _createVNode("span", null, [
                                          _createVNode(_component_el_button, {
                                            onClick: _withModifiers(($event: any) => (_ctx.fileList.splice(i, 1)), ["stop"]),
                                            type: "text"
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_23
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["http-request", "on-preview", "on-remove"])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode(_component_el_form_item, {
                    label: "问题回复：",
                    class: "tinymce-editor-wrap",
                    prop: "newReply",
                    "label-width": "70px"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_TinymceEditor, {
                        height: 200,
                        placeholder: "工单描述模板：比如什么时间，什么问题",
                        value: _ctx.ruleForm.newReply,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.ruleForm.newReply = $event)),
                        ref: "refTinymceEditor"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  (_ctx.imageList(_ctx.fileList).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "附件:",
                        "label-width": "70px"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_25, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (file, i) => {
                              return (_openBlock(), _createBlock(_Fragment, null, [
                                (_ctx.checkImage(file.name))
                                  ? (_openBlock(), _createBlock("div", {
                                      key: file.key,
                                      class: "img-div"
                                    }, [
                                      _createVNode(_component_el_image, {
                                        src: file.url,
                                        "preview-src-list": [file.url],
                                        style: {"width":"100px","height":"80px"}
                                      }, null, 8, ["src", "preview-src-list"]),
                                      _createVNode("span", {
                                        class: "icon-del",
                                        onClick: ($event: any) => (_ctx.fileList.splice(i, 1))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withId(() => [
          _hoisted_27
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.viewType !== '已挂起')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "warning",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.delayed(_ctx.ruleFormData)))
          }, {
            default: _withId(() => [
              _hoisted_28
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "success",
        onClick: _ctx.ticketContinue
      }, {
        default: _withId(() => [
          _hoisted_29
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.ticketResolved
      }, {
        default: _withId(() => [
          _hoisted_30
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.showChangeTemplate)
      ? (_openBlock(), _createBlock(_component_ticket_template_change_multi, {
          key: 0,
          show: _ctx.showChangeTemplate,
          "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (_ctx.showChangeTemplate = $event)),
          "ticket-id-list": _ctx.ticketsId,
          "current-template-id": _ctx.templateId,
          onUpdate: _ctx.handleTemplateChange
        }, null, 8, ["show", "ticket-id-list", "current-template-id", "onUpdate"]))
      : _createCommentVNode("", true)
  ], 64))
})